<template>
  <div>
    <v-text-field
      v-model="search"
      label="Buscar suplemento..."
      prepend-inner-icon="mdi-magnify"
      outlined
      dense
      clearable
      color="catAmber"
      :loading="searching"
      @input="onSearchInput"
    ></v-text-field>

    <!-- Resultados da busca -->
    <div
      v-if="results.length > 0"
      class="supp-results mb-3 pa-3 rounded-lg"
      style="background: #f5f5f5"
    >
      <p class="caption grey--text text--darken-1 mb-2 font-weight-medium">
        Resultados — clique para adicionar:
      </p>
      <v-chip
        v-for="(supp, index) in results"
        :key="index"
        class="ma-1"
        outlined
        color="catAmber"
        small
        :disabled="isSelected(supp)"
        @click="add(supp)"
      >
        <v-icon left x-small>
          {{ isSelected(supp) ? "mdi-check" : "mdi-plus" }}
        </v-icon>
        {{ supp.label }}
      </v-chip>
    </div>
    <p
      v-else-if="search && search.length >= 2 && !searching"
      class="caption grey--text"
    >
      <v-icon small color="grey" class="mr-1">mdi-alert-circle-outline</v-icon>
      Nenhum suplemento encontrado
    </p>
    <p
      v-else-if="search && search.length < 2 && !searching"
      class="caption grey--text"
    >
      Digite ao menos 2 caracteres para buscar
    </p>

    <!-- Selecionados -->
    <div
      v-if="model.length > 0"
      class="mt-3 pa-3 rounded-lg"
      style="background: #fffbeb"
    >
      <p class="caption font-weight-medium mb-2" style="color: #b45309">
        <v-icon small color="catAmber" class="mr-1">mdi-check-circle</v-icon>
        Selecionados:
      </p>
      <v-chip
        v-for="(supp, index) in model"
        :key="'sel-' + index"
        class="ma-1"
        color="catAmber"
        text-color="white"
        small
        close
        @click:close="remove(index)"
      >
        <span class="ds-chip-label" :title="supp.label">{{ supp.label }}</span>
      </v-chip>
    </div>
    <v-alert
      v-if="model.length === 0"
      type="info"
      dense
      text
      class="mt-3 rounded-lg"
      icon="mdi-information-outline"
      color="catAmber"
    >
      Pesquise e adicione ao menos um suplemento
    </v-alert>
  </div>
</template>

<script>
import { searchSupplements } from "@/services/supplementService";

export default {
  name: "SupplementSearchField",

  props: {
    // Array de objetos de suplemento já selecionados
    value: { type: Array, default: () => [] },
  },

  data() {
    return {
      search: "",
      results: [],
      searching: false,
      debounceTimer: null,
    };
  },

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  beforeDestroy() {
    clearTimeout(this.debounceTimer);
  },

  methods: {
    onSearchInput() {
      clearTimeout(this.debounceTimer);
      if (!this.search || this.search.length < 2) {
        this.results = [];
        return;
      }
      this.debounceTimer = setTimeout(() => this.runSearch(), 400);
    },

    async runSearch() {
      this.searching = true;
      try {
        this.results = await searchSupplements(this.search);
      } catch (err) {
        console.error("Erro ao buscar suplemento:", err);
        this.results = [];
      } finally {
        this.searching = false;
      }
    },

    suppKey(supp) {
      return (
        supp.label ||
        [supp.name, supp.dosage, supp.presentation].filter(Boolean).join(" — ")
      ).toLowerCase();
    },

    isSelected(supp) {
      return this.model.some((m) => this.suppKey(m) === this.suppKey(supp));
    },

    add(supp) {
      if (!this.isSelected(supp)) {
        this.$emit("input", [...this.model, supp]);
      }
    },

    remove(index) {
      const next = this.model.slice();
      next.splice(index, 1);
      this.$emit("input", next);
    },
  },
};
</script>

<style scoped>
.supp-results {
  max-height: 220px;
  overflow-y: auto;
}
</style>
